import React from 'react'
import styles from './muted-content-placeholder.module.scss'

interface MutedContentPlaceholderProps {
    userName?: string // Only provided in full view
    userId: string
    onReveal?: () => void // Only provided in full view
    variant: 'thin' | 'full'
}

const MutedContentPlaceholder: React.FC<MutedContentPlaceholderProps> = ({
    userName,
    userId,
    onReveal,
    variant,
}) => {
    if (variant === 'thin') {
        return (
            <div className={styles.mutedPlaceholder}>
                <span className={styles.mutedText}>Content from a muted user</span>
            </div>
        )
    }

    // Full variant
    return (
        <div className={styles.mutedPlaceholderFull}>
            <span className={styles.mutedTextFull}>
                {userName ? `@${userName} (muted)` : 'Content from a muted user'}
            </span>
            {onReveal && (
                <button
                    className={styles.revealButton}
                    onClick={e => {
                        e.stopPropagation()
                        e.preventDefault()
                        onReveal()
                    }}
                >
                    Show
                </button>
            )}
        </div>
    )
}

export default MutedContentPlaceholder
